"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _rcTabs = _interopRequireWildcard(require("rc-tabs"));

var _TabContent = _interopRequireDefault(require("rc-tabs/lib/TabContent"));

var _ScrollableInkTabBar = _interopRequireDefault(require("rc-tabs/lib/ScrollableInkTabBar"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Tabs');

var _ref2 = /*#__PURE__*/_react.default.createElement(_ScrollableInkTabBar.default, null);

var _ref3 = /*#__PURE__*/_react.default.createElement(_TabContent.default, null);

function Tabs(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      tabs = _ref.tabs,
      onChange = _ref.onChange,
      activeKey = _ref.activeKey,
      position = _ref.position,
      postComponent = _ref.postComponent,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "tabs", "onChange", "activeKey", "position", "postComponent"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Tabs.overrides); // Classes

  var rootClassName = (0, _classnames2.default)(classes.root, classNameProp, (0, _defineProperty2.default)({}, classes.withPostComponent, postComponent));
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: rootClassName
  }, override.root), /*#__PURE__*/_react.default.createElement(_rcTabs.default, (0, _extends2.default)({
    activeKey: activeKey,
    onChange: onChange,
    renderTabBar: function renderTabBar() {
      return _ref2;
    },
    renderTabContent: function renderTabContent() {
      return _ref3;
    },
    tabBarPosition: position,
    prefixCls: "hoi-poi-ui__tabs"
  }, override['rc-tabs']), tabs.map(function (_ref4) {
    var key = _ref4.key,
        title = _ref4.title,
        content = _ref4.content;
    return /*#__PURE__*/_react.default.createElement(_rcTabs.TabPane, {
      key: key,
      tab: title
    }, content);
  })), postComponent && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.postComponent
  }, postComponent));
}

Tabs.overrides = ['root', 'rc-tabs'];
Tabs.defaultProps = {
  position: 'top',
  tabs: []
};
process.env.NODE_ENV !== "production" ? Tabs.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  tabs: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    title: _propTypes.default.string,
    content: _propTypes.default.node
  })),
  activeKey: _propTypes.default.string,
  onChange: _propTypes.default.func,
  position: _propTypes.default.oneOf(['left', 'right', 'top', 'bottom']),
  postComponent: _propTypes.default.node
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Tabs);

exports.default = _default;